import { inject, Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { VariablesService } from '@services/variables/variables.service';
import { PaymentService } from '@services/payment/payment.service';
import { InrFormatPipe } from '@pipes/inr-format/inr-format.pipe';

@Component({
  selector: 'app-sip-monthly-donor-count',
  standalone: true,
  imports: [
    InrFormatPipe
  ],
  templateUrl: './sip-monthly-donor-count.component.html',
  styleUrls: ['./sip-monthly-donor-count.component.scss']
})
export class SipMonthlyDonorCountComponent {

  readonly payments = inject(PaymentService);
  public vars = inject(VariablesService);

  supporterImg;
  subsCount;
  subs: Subscription[] = [];

  ngOnInit() {
    this.supporterImg = `/assets/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
    this.payments.getSubsCount();
    this.subs.push(this.vars.subsCount.subscribe((res: any) => {
      this.subsCount = res;
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
